function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "clipboard@1x");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Backoffice",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "Super-Admin---Menu",
  transform: "translate(-1171.000000, -222.000000)",
  stroke: "#637280",
  strokeWidth: 1.6
}, React.createElement("g", {
  id: "clipboard",
  transform: "translate(1172.000000, 223.000000)"
}, React.createElement("path", {
  d: "M9.6,1.6 L11.2,1.6 C12.0836556,1.6 12.8,2.3163444 12.8,3.2 L12.8,14.4 C12.8,15.2836556 12.0836556,16 11.2,16 L1.6,16 C0.7163444,16 0,15.2836556 0,14.4 L0,3.2 C0,2.3163444 0.7163444,1.6 1.6,1.6 L3.2,1.6",
  id: "Path"
}), React.createElement("rect", {
  id: "Rectangle",
  x: 3.2,
  y: 0,
  width: 6.4,
  height: 3.2,
  rx: 1
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/backoffice.4daf4535.svg";
export { SvgComponent as ReactComponent };